import { BreadcrumbModel, Category, Sort } from './CategoryDetail';

export enum DISCOUNT_TYPE {
  NONE = 0,
  PERCENT = 2,
  AMOUNT = 3,
}

export enum PRODUCT_TYPE {
  FLOWER = 2,
  CHOCOLATE = 5,
  GIFT = 10,
  SPRAY = 30,
  /** Araç süsleme — depo + saat dilimi ile rezervasyon */
  VEHICLE_DECORATION = 40,
  PHOTO_PRINT = 50,
}

export interface ProductsWithSort {
  products: Product[];
  sort: Sort[];
}

export interface ProductDetail {
  product: Product;
}

export interface Product {
  id: number;
  inStock: number;
  code: string;
  title: string;
  titleWD: string;
  categories?: string[];
  categoryName?: string;
  imageUrl: string;
  url: string;
  price: number;
  priceBeforeDiscount?: number;
  images: ProductImage[];
  badge?: ProductBadge;
  breadcrumb?: BreadcrumbModel[];
  category?: Category;
  seo?: Seo;
  isExtra: boolean;
  otherOptions?: Product[];
  reviewData?: ReviewData;
  productTypeId?: PRODUCT_TYPE;
  ldCategory?: string;
  showCaptionDialog?: boolean;
  recommendedProducts?: Array<{
    product_id: number;
    order_id: number;
    tier_id?: number;
  }>;
}

export interface ReviewData {
  ratingCount: number;
  reviewCount: number;
  averageRating: number;
}

export interface ProductImage {
  imageUrl: string;
  alt?: string | null;
}

export interface ProductBadge {
  title: string;
  imageUrl: string;
  badgeEndTime?: string;
  discountType?: DISCOUNT_TYPE;
  discountAmount?: number;
}

export interface TownLandingLink {
  id: number;
  title: string;
  url: string;
}

export interface Seo {
  id: number;
  contentType: number;
  url: string;
  title: string;
  description: string;
  seoDescription: string;
  script?: string;
  seoKeywords: string;
  content: string;
  ogImageUrl?: string;
  hideFromRobots?: boolean;
  towns?: TownLandingLink[];
}

export interface SeoResponse {
  slugProps?: Seo;
}

export interface RedirectResponse {
  from?: string;
  to?: string;
}

export interface PriceDataContainer {
  items: PriceData;
}

export interface PriceData {
  [key: string]: PriceDataDetails;
}
export interface PriceDataDetails {
  price: number;
  priceBeforeDiscount?: number;
  badge?: ProductBadge;
}
